import { Injectable } from '@angular/core';
import { AssignmentPermissions, DashboardAssignmentChangesModel } from 'src/AngularJS/Dashboard/dashboard-assignment.model';
import { CVApiService } from '../../services/cv-api.service';

@Injectable({
    providedIn: 'root'
})
export class DashboardAssignmentService {
    /** Used to keep track of which permission warnings have already been acknowledged */
    acknowledgedWarnings = new Set<AssignmentPermissions>();

    constructor(
        private cvApiService: CVApiService,
    ) { }

    async saveDashboardAssignments(dashboardKeys: string[], changes: DashboardAssignmentChangesModel[]) {
        const url = `/api/v2/shared-dashboards/update`;
        const response = await this.cvApiService.post<undefined>(url, { dashboardKeys, changes });
        if (response.status_code >= 200 && response.status_code < 300)
            return response.data;
        else
            throw response;
    }
}
